/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerAuditLogDto } from '../models/EntityModelResponseContainerAuditLogDto';
import type { PagedModelEntityModelAuditLogDto } from '../models/PagedModelEntityModelAuditLogDto';
import type { PagedResourcesAssemblerAuditLogDto } from '../models/PagedResourcesAssemblerAuditLogDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramAuditLogControllerService {
    /**
     * @returns PagedModelEntityModelAuditLogDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        user,
        type,
        auditId,
        after,
        before,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerAuditLogDto,
        user?: string,
        type?: 'CREATE' | 'READ' | 'UPDATE' | 'DELETE' | 'LIST' | 'PROPERTY_UPDATE' | 'LOGIN',
        auditId?: string,
        after?: string,
        before?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelAuditLogDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/audit-logs',
            query: {
                'user': user,
                'type': type,
                'auditId': auditId,
                'after': after,
                'before': before,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerAuditLogDto OK
     * @throws ApiError
     */
    public static read({
        id,
    }: {
        id: number,
    }): CancelablePromise<EntityModelResponseContainerAuditLogDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/audit-logs/{id}',
            path: {
                'id': id,
            },
        });
    }
}
